import { render, staticRenderFns } from "./UserEditProfile.vue?vue&type=template&id=d97c5be0&"
import script from "./UserEditProfile.vue?vue&type=script&lang=js&"
export * from "./UserEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports